import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FullScreen',
  setup(__props) {

const isFullScreen = ref(false)

const toggleFullScreen = () => {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen()
    isFullScreen.value = true
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen()
      isFullScreen.value = false
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    effect: "dark",
    content: isFullScreen.value ? '退出全屏' : '全屏模式',
    placement: "top"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_app_icon, {
        class: "c_cursor",
        size: 20,
        name: isFullScreen.value ? 'fullscreen-exit-line' : 'fullscreen-line',
        onClick: toggleFullScreen
      }, null, 8, ["name"])
    ]),
    _: 1
  }, 8, ["content"]))
}
}

})